import { render, staticRenderFns } from "./KitItemsTooltip.vue?vue&type=template&id=1473e6b2"
import script from "./KitItemsTooltip.vue?vue&type=script&lang=js"
export * from "./KitItemsTooltip.vue?vue&type=script&lang=js"
import style0 from "./KitItemsTooltip.vue?vue&type=style&index=0&id=1473e6b2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports